import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTenant } from "../../context/TenantContext";
import api from "../../services/api";
import {
  getMarketingVisitorSessionId,
  getStoredConsentPreferences,
  hasMarketingConsent,
  persistMarketingConsent,
  setTrackingConfig,
  trackMarketingEvent,
} from "../../utils/marketingTracking";
import { isAdminStorefrontPreview } from "../../utils/storefrontPreview";

const MarketingTrackingManager = () => {
  const location = useLocation();
  const { tenantCode } = useTenant();
  const [consentRevision, setConsentRevision] = useState(0);
  const [consentReady, setConsentReady] = useState(false);

  useEffect(() => {
    let active = true;
    const loadSettings = async () => {
      if (isAdminStorefrontPreview()) {
        setTrackingConfig({});
        if (active) setConsentReady(true);
        return;
      }
      const preferences = getStoredConsentPreferences();
      if (!preferences) {
        setTrackingConfig({});
        if (active) setConsentReady(true);
        return;
      }
      try {
        await persistMarketingConsent(preferences);
        if (hasMarketingConsent() && tenantCode) {
          const response = await api.get("/api/marketing/tracking", {
            params: { visitorSessionId: getMarketingVisitorSessionId() },
          });
          if (active) setTrackingConfig(response.data.settings);
        } else if (active) {
          setTrackingConfig({});
        }
        if (active) setConsentReady(true);
      } catch (error) {
        console.warn("Could not load marketing tracking configuration:", error);
        if (active) setTrackingConfig({});
      }
    };
    const handleConsentUpdate = async () => {
      setConsentReady(false);
      await loadSettings();
      setConsentRevision((revision) => revision + 1);
    };
    loadSettings();
    window.addEventListener("cookieConsentUpdated", handleConsentUpdate);
    return () => {
      active = false;
      window.removeEventListener("cookieConsentUpdated", handleConsentUpdate);
    };
  }, [tenantCode]);

  useEffect(() => {
    if (isAdminStorefrontPreview()) return;
    if (!consentReady || !hasMarketingConsent()) return;
    if (location.pathname.startsWith("/admin")) return;
    if (/^\/(login|register|forgot-password|reset-password|dashboard|notifications|order-confirmation|orders|track-order)(\/|$)/.test(location.pathname)) return;
    trackMarketingEvent(
      location.pathname === "/checkout" ? "begin_checkout" : "page_view",
    );
  }, [consentReady, consentRevision, location.key, location.pathname]);

  return null;
};

export default MarketingTrackingManager;
